import { useState } from 'react';

export default function useForm(callback) {

  const [values, setValues] = useState({});

  const handleSubmit = event => {
    if (event) {
      event.preventDefault();
    }
    callback();
  };

  const handleInputChange = event => {
    event.persist();
    let { name, value } = event.target;


    if(event.target.type === 'checkbox') {
      if(value === "on") {
        value = true;
      } else if (value === "off") {
        value = false;
      }
    }


    console.log(event.target, name, value)
    setValues(values => ({
      ...values,
      [name]: value
    }));
  };

  const resetInputValue = event => {
    const { name } = event.target;
    setValues(values => ({
      ...values,
      [name]: ''
    }));
  };

  const updateValues = newValues => {
    setValues(values => ({
      ...values,
      ...newValues
    }));
  }



  return {
    handleInputChange,
    handleSubmit,
    resetInputValue,
    values,
    setValues,
    updateValues
  };
}
